export default __webpack_public_path__ + "5795f1068929e51de5a1a681a2af41e3.ttf";